const getFeatureFlag = () => {
    if (window.sessionStorage)
        return sessionStorage.getItem('feature_flag_override');
    return null;
};
export { getFeatureFlag };
